import { useMutation, useQueryClient } from 'react-query';

import { actionTemplatesApi } from 'config/api/actionLibrary/actionLibrary';

type PublishVariables = {
  id: number;
  data: { confirmation: boolean };
};

const usePublishActionTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(({ id, data }: PublishVariables) => actionTemplatesApi.publishActionTemplate(id, data), {
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(['actionTemplate', variables.id.toString()]);
      queryClient.invalidateQueries(['actionTemplates']);
    },
  });
};

export default usePublishActionTemplate;
